// This file was auto-generated by Fern from our API Definition.
export const SessionExpansion = {
    LastMessage: "last_message",
    Trigger: "trigger",
};
